import { Check, QrCode } from 'lucide-react'
import { useEffect, useState } from 'react'
import { generateQRCode } from '../utils/qrcode'

export function QRCard({
  id,
  url,
  selected,
  onClick,
  status,
  renderInfo,
}: {
  id: string
  url: string
  selected: boolean
  onClick: () => void
  status?: { label: string; color: string; bgColor: string }
  renderInfo: React.ReactNode
}) {
  const [qr, setQr] = useState<string>('')

  useEffect(() => {
    generateQRCode(url).then(setQr)
  }, [url])

  return (
    <div
      onClick={onClick}
      className={`flex flex-col items-center gap-3 rounded-lg border-2 p-4 transition-all cursor-pointer ${
        selected ? 'border-primary bg-primary/5' : 'border-border/30 bg-secondary/20 hover:border-border/60'
      }`}
    >
      {/* Top bar */}
      <div className="flex w-full items-center justify-between">
        <div
          className={`flex size-5 items-center justify-center rounded border ${
            selected ? 'border-primary bg-primary' : 'border-border'
          }`}
        >
          {selected && <Check className="size-3 text-primary-foreground" />}
        </div>

        {status && (
          <span
            className={`inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[10px] font-medium ${status.bgColor} ${status.color}`}
          >
            <span className="size-1.5 rounded-full bg-current" />
            {status.label}
          </span>
        )}
      </div>

      {/* QR */}
      <div className="rounded-lg bg-white p-2">{qr ? <img src={qr} width={120} /> : <QrCode className="size-8" />}</div>

      {/* Info */}
      <div className="flex w-full flex-col items-center gap-1 text-center">{renderInfo}</div>
    </div>
  )
}
